var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"container"},[_vm._m(0),_c('socials'),_c('span',[_vm._v("All rights reserved, 2021")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"holder"},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"logo",attrs:{"width":"130","height":"76","src":require("../assets/LOGO-white.svg")}})])])
}]

export { render, staticRenderFns }